<div class="lightbox-backdrop" (click)="onBackdropClick($event)">
  <button class="lightbox-close" (click)="close()">
    <fa-icon [icon]="faXmark"></fa-icon>
  </button>

  @if (hasMultipleItems) {
    <button class="lightbox-nav lightbox-prev" (click)="previous()">
      <fa-icon [icon]="faChevronLeft"></fa-icon>
    </button>
  }

  <div class="lightbox-content">
    @if (currentItem) {
      @if (currentItem.mediaType === 'video') {
        <video class="lightbox-video" [src]="currentItem.url" controls autoplay></video>
      } @else {
        <img class="lightbox-image" [src]="currentItem.url" [alt]="currentItem.title || ''">
      }
      @if (currentItem.title) {
        <div class="lightbox-caption">{{ currentItem.title }}</div>
      }
      @if (hasMultipleItems) {
        <div class="lightbox-counter">{{ currentIndex + 1 }} / {{ items.length }}</div>
      }
    }
  </div>

  @if (hasMultipleItems) {
    <button class="lightbox-nav lightbox-next" (click)="next()">
      <fa-icon [icon]="faChevronRight"></fa-icon>
    </button>
  }
</div>
